/** Zustand meta-data state for the page */

import type { IconName } from '@tunasong/icons'
import { create } from 'zustand'

const defaultName = 'Tunasong'
const defaultDescription = 'Tunasong - Human musical creativity in the age of AI'

/** Global state. We want to render `formDialog` on top (app) level */
export const usePageMetadata = create<{
  name: string
  description: string
  pageIconName: IconName
  setName: (pageName: string) => void
  setDescription: (pageDescription: string) => void
  setPageIconName: (pageIconName: IconName) => void
  /** Back to the app's own name and description, for a page that leaves without naming the next one (GH #2862) */
  resetMetadata: () => void
}>(set => ({
  name: defaultName,
  description: defaultDescription,
  pageIconName: 'Page',
  setName: (pageName: string) => set({ name: pageName }),
  setDescription: (pageDescription: string) => set({ description: pageDescription }),
  setPageIconName: (pageIconName: IconName) => set({ pageIconName }),
  resetMetadata: () => set({ name: defaultName, description: defaultDescription }),
}))
